import { useEffect, useState } from 'react'
import Popup from '../../Components/Popup';
import { compressImage, getAllBuildings, getAllUsers, CustomParseSafeHtml, isValidEmail, LogInSchoolID, GetAllGroups } from '../../JS/Common';
import { ApiCmnHeadersPostCall, ApiGetCall, ApiGetCallAuthKey } from '../../JS/Connector';
import VideoUpload from './VideoUpload';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';


export default function QuickAddTickets(props) {
    const { staff_member, manager_user, user_no } = useConfig();
    const [MainCategories, setMainCategories] = useState([]);
    const [SubCategories, setSubCategories] = useState([]);
    const [IssueTypes, setIssueTypes] = useState([]);
    const [error, setError] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [selectedIssue, setSelectedIssue] = useState(null);

    const [Alldata, setAlldata] = useState({
        Flag: 2,
        Buildingid: "",
        Buildingname: "",
        Roomno: "",
        RoomName: "",
        Title: "",
        Name: "",
        Email: "",
        StudentNumber: "",
        Description: "",
        Filename: "",
        Document: "",
        AssigneeId: "",
        assign_flag: 0,
    });
    const [Video, setVideo] = useState(null);
    const [Buildings, setBuildings] = useState([]);
    const [RoomData, setRoomData] = useState([]);
    const [EmailValidation, setEmailValidation] = useState("");
    const [AssigneeId, setAssigneeId] = useState([])
    const [AllGroups, setAllGroups] = useState([])
    const [isCheckedForOther, setIsCheckedForOther] = useState(false);
    const [showTicketForm, setshowTicketForm] = useState(false);
    const [BuildingValidation, setBuildingValidation] = useState("");
    const [CategoryValidation, setCategoryValidation] = useState("");

    useEffect(() => {
        async function fetchData() {
            try {
                const result = await ApiGetCall(`/helpdesk/types?schoolId=${LogInSchoolID}&flag=${props.type}`);
                if (!result) {
                    alert("Something went wrong");
                    return;
                }
                const response = JSON.parse(result);
                if (response[0].categories) {
                    setMainCategories(response[0]);
                }
            } catch (e) {
                log.error(e);
            }
        }
        fetchData();
        getAllBuildings(setBuildings, LogInSchoolID);
        getAllUsers(setAssigneeId);
        GetAllGroups({ setAllGroups })
    }, []);

    const handleCategoryChange = (event) => {
        const categoryId = event.target.value;
        const selected = MainCategories.categories?.find(cat => cat.id === categoryId);
        setSelectedCategory(selected);
        setSubCategories(selected ? selected.subcategories : []);
        if (selected?.subcategories?.length == 0) {
            setshowTicketForm(true);
        }
        setIssueTypes([]); // Reset issues when category changes
        setSelectedSubCategory(null);
        setCategoryValidation("");
    };
    const handleSubCategoryChange = (event) => {
        const subCategoryId = event.target.value;
        const selected = SubCategories.find(sub => sub.id === subCategoryId);
        setSelectedSubCategory(selected);
        setIssueTypes(selected ? selected.subcategories || [] : []);
        if (selected.subcategories.length == 0) {
            setshowTicketForm(true);
        }
    };
    const handleIssueTypes = (event) => {
        const issueId = event.target.value;
        const selected = IssueTypes.find(issue => issue.id === issueId);
        setSelectedIssue(selected);
        setshowTicketForm(true)
    };
    function getRooms(buildingid) {
        ApiGetCallAuthKey(`/buildings?uuid=${buildingid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setRoomData(responseRs.msg?.room)
            }
        });
    }
    async function handleImageFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
            setAlldata({ ...Alldata, Document: "", Filename: "" });
            setError(validationMsg);
            return;
        }
        const compressedImaage = await compressImage(file)
        const reader = new FileReader();
        reader.onload = function (event) {
            setAlldata({ ...Alldata, Document: compressedImaage, Filename: compressedImaage.name });
            setError("");
        };
        reader.readAsDataURL(file);
    };
    const modalBody = (
        <div className='row parent' id="quickaddform">
            <div className='col-md-4 py-2'>
                <label className='font-13 pb-2'>Choose Category : </label>
                <select className="mb-1 px-0" onChange={handleCategoryChange} disabled={showTicketForm}>
                    <option value="0">Choose Category</option>
                    {MainCategories?.categories?.sort((a, b) => a.name.localeCompare(b.name)).map(category => (
                        <option key={category.id} value={category.id}>{category.name}</option>
                    ))}
                </select>
                {CategoryValidation && <span className="custom-text-danger">{CategoryValidation}</span>}
            </div>
            {selectedCategory &&
                SubCategories?.length > 0 &&
                <div className='col-md-4 py-2'>
                    <label className='font-13 pb-2'>Choose Subcategory : </label>
                    <select className="mb-1 px-0" onChange={handleSubCategoryChange} disabled={showTicketForm}>
                        <option value="0">Choose Subcategory</option>
                        {SubCategories.map(subcategory => (
                            <option key={subcategory.id} value={subcategory.id}>{subcategory.name}</option>
                        ))}
                    </select>
                </div>
            }
            {selectedSubCategory &&
                IssueTypes?.length > 0 &&
                <div className='col-md-4 py-2'>
                    <label className='font-13 pb-2'>Choose the type of issue : </label>
                    <select className="mb-1 px-0" onChange={handleIssueTypes} disabled={showTicketForm}>
                        <option value="0">Choose issue</option>
                        {IssueTypes.map(issue => (
                            <option key={issue.id} value={issue.id}>{issue.name}</option>
                        ))}
                    </select>
                </div>
            }
            {selectedIssue && <div className='col-12 py-2'>
                <label className='font-13 pb-2'>Description :  </label>
                <span>{CustomParseSafeHtml(selectedIssue.description || '-')}</span>
            </div>
            }

            {showTicketForm &&
                <div className='row py-2'>
                    <div className='col-12 text-center'>
                        <u> <b className=''>Create your ticket below:</b></u>
                    </div>
                    <div className="col-12 text-center font-15 row pt-3">
                        <div className='d-flex align-items-center font-13'>
                            <b className='pe-5 font-12' style={{ color: "#495057" }}>Role:</b>
                            <div className="form-check mb-0">
                                <input className="form-check-input cursor-pointer" type="radio"
                                    name='role' defaultChecked={Alldata.Flag == 2}
                                    onChange={(e) => { setAlldata({ ...Alldata, Flag: 2 }) }} />
                                <label className="form-check-label"> {staff_member}</label>
                            </div>
                            <div className="form-check ms-3 mb-0">
                                <input className="form-check-input cursor-pointer" type="radio"
                                    name='role' defaultChecked={Alldata.Flag == 1}
                                    onChange={(e) => { setAlldata({ ...Alldata, Flag: 1 }) }} />
                                <label className="form-check-label"> {manager_user} </label>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 pb-2'>
                        <div className="align-items-center row py-2">
                            <b className="font-12" style={{ color: "#495057" }}>
                                Is there a specific building for this issue?</b>
                        </div>
                        <div className="row">
                            {Buildings.map((item, i) => {
                                return <div className="col-md-3 d-flex align-items-start py-1 font-13 text-break">
                                    <input type="radio" className="form-check-input me-2"
                                        onChange={(e) => {
                                            setAlldata({
                                                ...Alldata, Buildingid: item.id, Buildingname: '',
                                                Roomno: "", RoomName: ""
                                            });
                                            setIsCheckedForOther(false);
                                            getRooms(item.id)
                                        }}
                                        name={"building"} bid={item.id}
                                    />
                                    {item.name}
                                </div>
                            })}
                            <div className="col-md-3 py-1 font-13">
                                <input type="radio" className="form-check-input me-2" name={"building"}
                                    checked={isCheckedForOther} onChange={(e) => {
                                        setAlldata({
                                            ...Alldata, Buildingid: 0, Buildingname: '',
                                            Roomno: "", RoomName: ""
                                        });
                                        setRoomData([]);
                                        setIsCheckedForOther(e.target.checked)
                                    }}
                                />
                                Other
                            </div>
                            <span style={{ fontSize: '.875em', color: "var(--error_text_color)" }}>{BuildingValidation}</span>
                        </div>
                    </div>
                    {isCheckedForOther == true && (
                        <div className='col-4 py-3'>
                            <input type="text" placeholder="Enter Building*" required autoComplete='off' name='building' className="form-control" value={Alldata.Buildingname}
                                onChange={(e) => setAlldata({ ...Alldata, Buildingname: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    )}
                    <div className='col-md-4 py-3'>
                        <div className='col-12'>
                            <input type="text" placeholder="Subject*" autoComplete='off' name='Title' className="form-control" required value={Alldata.Title} onChange={(e) => setAlldata({ ...Alldata, Title: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                    <div className='col-md-4 py-3'>
                        <div className='col-12'>
                            <input type="text" placeholder="Name*" autoComplete='off' name='name' className="form-control" required value={Alldata.Name} onChange={(e) => setAlldata({ ...Alldata, Name: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                    <div className='col-md-4 py-3'>
                        <div className='col-12'>
                            <input type="email" placeholder="Email*" autoComplete='off' name='email' className="form-control" value={Alldata.Email} onChange={(e) => setAlldata({ ...Alldata, Email: e.target.value })} />
                            <span style={{ fontSize: '.875em', color: "var(--error_text_color)" }}>{EmailValidation}</span>
                        </div>
                    </div>
                    {Alldata.Flag != 1 && (
                        <div className='col-md-4 py-3'>
                            <div className='col-12'>
                                <select value={Alldata.Roomno} onChange={(e) => {
                                    setAlldata({ ...Alldata, Roomno: e.target.value, RoomName: "" });
                                }}>
                                    <option value="0">Select Room</option>
                                    {RoomData?.length &&
                                        RoomData?.map((item, i) => {
                                            return <option key={i} value={item.id}>{item.name}</option>
                                        })
                                    }
                                    <option value="other">Other</option>
                                </select>
                            </div>
                        </div>
                    )}
                    {Alldata.Roomno == "other" && (
                        <div className='col-4 py-3'>
                            <input type="text" placeholder="Enter Room*" required autoComplete='off' name='building' className="form-control" value={Alldata.RoomName} onChange={(e) => setAlldata({ ...Alldata, RoomName: e.target.value })} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    )}
                    <div className='col-md-4 py-3'>
                        <div className='col-12'>
                            {Alldata.Flag != 1 ?
                                <input type="text" placeholder={user_no} autoComplete='off' name='studentno' className="form-control" value={Alldata.StudentNumber} onChange={(e) => setAlldata({ ...Alldata, StudentNumber: e.target.value.toUpperCase() })} />
                                :
                                <>
                                    <input type="text" placeholder={user_no + "*"} required autoComplete='off' name='studentno' className="form-control" value={Alldata.StudentNumber} onChange={(e) => setAlldata({ ...Alldata, StudentNumber: e.target.value.toUpperCase() })} />
                                    <span className="form-text invalid-feedback">
                                        *required
                                    </span>
                                </>
                            }
                        </div>
                    </div>
                    <div className='col-md-4 py-3'>
                        <input type="file" label="img" id="UploadFileId" name="myFile" accept=".jpg,.png,.jpeg" onChange={(e) => handleImageFileUpload(e)} />
                        <label className="supportTicketbtn col-md-12 cursor-pointer" htmlFor="UploadFileId" style={{ color: "#909091" }}>
                            Choose File (Attach Image)
                        </label>
                        {Alldata.Filename && <label className="ps-2 mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{Alldata.Filename} </label>}
                        {error?.trim() != "" && <label className='redText'>{error}</label>}
                    </div>
                    <div className='col-md-4 py-3'>
                        <select className="mb-1 px-0" onChange={(e) => {
                            const selectedValue = e.target.value;
                            const selectedOption = e.target.options[e.target.selectedIndex];
                            const flag = selectedOption.dataset.type == 'AssigneeId' ? 2 : 1;
                            setAlldata({ ...Alldata, AssigneeId: selectedValue, assign_flag: flag });
                        }}>
                            <option value="0">Select Assigned To</option>
                            {AssigneeId.map((item1, j) => (
                                <option value={item1.id} key={j} data-type="AssigneeId">
                                    {item1.name}
                                </option>
                            ))}
                            {AllGroups.map((item2, k) => (
                                <option style={{ color: "blue" }} value={item2.id} key={k} data-type="AllGroups" >
                                    {item2.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <VideoUpload selectedFile={(e) => setVideo(e)} />
                    <div className="col-md-12 pb-3">
                        <textarea placeholder="Ticket Description" type="textarea" rows={3} autoComplete="off" name="RepairedNm" className="form-control" value={Alldata.Description} onChange={(e) => setAlldata({ ...Alldata, Description: e.target.value })} />
                    </div>
                </div>
            }
        </div>
    )
    const SaveComment = async () => {
        var isFormValid = CheckValidation({ formID: 'quickaddform' });
        var emailvalid = isValidEmail(Alldata.Email);
        if (selectedCategory == null) {
            setCategoryValidation("*required");
            return;
        } else {
            setCategoryValidation("");
        }
        if (emailvalid == false) {
            setEmailValidation("Invalid Email")
            isFormValid = false;
        } else {
            setEmailValidation("");
        }
        if (Alldata.Buildingid === '') {
            setBuildingValidation("*required");
            isFormValid = false;
        } else {
            setBuildingValidation("");
        }
        if (!isFormValid) return;
        props.setLoading(true);

        const formdata = new FormData();
        formdata.append('schoolId', LogInSchoolID);
        formdata.append('typeId', props.type);
        formdata.append('hdTypeId', MainCategories?.id);
        formdata.append('categoryId', selectedCategory?.id);
        formdata.append('subCategoryId', selectedSubCategory ? selectedSubCategory?.id : "");
        formdata.append('issueId', selectedIssue ? selectedIssue?.id : "");
        formdata.append('requesterType', Alldata.Flag);
        formdata.append('name', Alldata.Name);
        formdata.append('email', Alldata.Email);
        formdata.append('roomNumberId', Alldata.Roomno == "other" ? 0 : Alldata.Roomno);
        formdata.append('roomName', Alldata.RoomName);
        formdata.append('studentNumber', Alldata.StudentNumber);
        if (Alldata.Document != null) {
            formdata.append('document', Alldata.Document);
        }
        if (Video != null) {
            formdata.append('video', Video);
        }
        formdata.append('description', Alldata.Description);
        formdata.append('title', Alldata.Title);
        formdata.append('buildingId', Alldata.Buildingid);
        formdata.append('buildingName', Alldata.Buildingname);
        formdata.append('assignedToId', Alldata.AssigneeId);
        formdata.append('assignedFlag', Alldata.assign_flag);

        ApiCmnHeadersPostCall(`/support-tickets/quick-add`, formdata)
            .then(result => {
                props.setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.response == "success") {
                    props.closepopup();
                    props.setAlerts(<AlertsComp show={true} variant="success" msg="Ticket added successfully" />);
                    props.getcall();
                    setTimeout(() => {
                        props.setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    props.setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        props.setAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
                props.setLoading(false);
            })
            .catch(error => log.error('error', error));
    }
    return (
        <Popup isshow={props.isShow} size={"lg"} title={props.type == 1 ? "Add Technology Help Desk Ticket" : "Add Maintenance Help Desk Ticket"}
            closePopup={(e) => { props.closepopup(); setAlldata({ ...Alldata, Document: "", Filename: "" }) }}
            modalBody={modalBody} handleSave={SaveComment} visibleSaveBtn={true} btnText={"Add"} />
    )
}
